import PropTypes from 'prop-types'

export const NOTHING = 'NOTHING'
export const LOGIN = 'LOGIN'
export const REGISTER = 'REGISTER'
export const RESET = 'RESET'
export const CONFIRM = 'CONFIRM'

export const LOGIN_TITLE = 'Log in'
export const REGISTER_TITLE = 'Create account'
export const RESET_PASSWORD_TITLE = 'Reset password'
export const CONFIRM_PASSWORD_TITLE = 'Link your account'

export const PROP_TYPES_VIEW = PropTypes.oneOf([
  LOGIN,
  REGISTER,
  RESET,
  CONFIRM,
  NOTHING,
])
